import { cuartApi } from 'api/axios'
import { lockersUrls } from './lockers.urls'

export const userLogin = async () => {
  try {
    const { headers, status } = await cuartApi.post(lockersUrls.login, {
      collect_user: {
        email: process.env.REACT_APP_CUART_EMAIL,
        password: process.env.REACT_APP_CUART_PASSWORD,
      },
    })

    if (status === 200) {
      const token = headers.authorization
      return token
    } else {
      throw new Error()
    }
  } catch (error) {
    console.error('Error en login:', error)
    throw error
  }
}

export const listLockers = async () => {
  const { status, data } = await cuartApi.get(lockersUrls.machines)

  if (status === 200) {
    return data
  }

  throw new Error('Erro al obtener los lockers')
}

export const slotsByLocker = async lockerId => {
  const { status, data } = await cuartApi.post(lockersUrls.listSlot, {
    machine_id: lockerId,
    state_id: 3,
  })

  if (status === 200) {
    return data
  }

  throw new Error('Erro al obtener los slock del locker')
}
const formattedErrorString = errorObject =>
  Object.entries(errorObject)
    .map(([key, value]) => `${key}: ${value}`)
    .join('\n')

export const updateSlot = async (
  slotId,
  {
    customerName,
    customerDocument,
    customerEmail,
    customerCellphone,
    orderNumber,
    description,
  }
) => {
  try {
    const { status, data } = await cuartApi.put(
      `${lockersUrls.slots}${slotId}`,
      {
        cc_name: customerName,
        cc_document: customerDocument,
        cc_email: customerEmail,
        cc_cellphone: customerCellphone,
        order_number: orderNumber,
        cc_description: description,
      }
    )

    if (status === 200) {
      const errorMessage = data.message
      if (errorMessage) {
        throw new Error(
          `Error al reservar el slot:\n${formattedErrorString(errorMessage)}`
        )
      }

      return data
    }
  } catch (error) {
    const { status, data } = error.response || {}

    if (status === 400 && data) {
      throw new Error(
        `Error al reservar el slot:\n${formattedErrorString(data)}`
      )
    }

    // Si no es un error 400, lanzar el error como está
    throw error
  }
}
